// extracted by mini-css-extract-plugin
module.exports = {"img":"styles-module--img--2B1I0","list":"styles-module--list--1fDst","wrapper":"styles-module--wrapper--1pAbd"};